'use strict';

var GetIntrinsic = require('get-intrinsic');

/** @type {import('.')} */
var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;



// WEBPACK FOOTER //
// ./~/gopd/index.js